import { createFileRoute, Outlet } from '@tanstack/react-router'
import { recurringQueryOptions } from '../../../../../features/finance/queries'

export const Route = createFileRoute('/_app/expenses/recurring/$recurringId')({
  staticData: { crumb: 'recurringExpense' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(recurringQueryOptions(params.recurringId)),
  component: Outlet,
})
